import { HStack, VStack } from '@chakra-ui/react';
import { ScrollArea } from '@components/ui/ScrollArea';
import { ReactNode } from 'react';

interface CockpitListLayoutProps {
  dialog?: ReactNode;
  actions?: ReactNode;
  header?: ReactNode;
  filters?: ReactNode;
  children?: ReactNode;
}

export function CockpitListLayout({ dialog, actions, header, children, filters }: Readonly<CockpitListLayoutProps>) {
  return (
    <VStack boxSize="100%" gap={0.25}>
      {dialog}
      {actions && (
        <HStack
          width="100%"
          paddingLeft={5}
          height="56px"
          flexShrink={0}
          backgroundColor="neutral.850"
          cursor="default"
          userSelect="none"
        >
          {actions}
        </HStack>
      )}
      <HStack width="100%" flex={1} minHeight={0} gap={0.25} backgroundColor="neutral.black">
        {filters && (
          <VStack width="min-content" flexShrink={0} height="100%">
            {filters}
          </VStack>
        )}
        <VStack width="100%" height="100%" gap={0.25}>
          {header && (
            <HStack
              paddingLeft={5}
              flexShrink={0}
              width="100%"
              height="54px"
              gap={2}
              justifyContent="start"
              backgroundColor="neutral.900"
              cursor="default"
              userSelect="none"
            >
              {header}
            </HStack>
          )}
          <ScrollArea backgroundColor="neutral.800">
            <VStack boxSize="100%" gap={0}>
              {children}
            </VStack>
          </ScrollArea>
        </VStack>
      </HStack>
    </VStack>
  );
}
